import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Panel} from "primereact/panel";
import {Dropdown} from "primereact/dropdown";
import {ProgressBar} from "primereact/progressbar";
import {Card} from "primereact/card";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import HelpComponent from "../HelpComponent";

const _FM_EzeeroomtypesDndComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);
  const [accommodations, setAccommodations] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [categories, setCategories] = useState([]);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  const handleDragStart = (event, item) => {
    event.dataTransfer.setData("text/plain", JSON.stringify(item));
    document.querySelectorAll('.dropzone').forEach((div) => {
      div.classList.add('active');
    });
  };

  const handleDragEnd = (event, item) => {
    document.querySelectorAll('.dropzone').forEach((div) => {
      div.classList.remove('active');
    });
  };

  const handleDrop = (event, target) => {
    event.preventDefault();
    const droppedItem = JSON.parse(event.dataTransfer.getData("text/plain"));
    // console.log(target)
    // console.log(droppedItem)
    setLoading(true)
    const selectedValue = droppedItem.id;
    const existsInCategories = categories.some(target => target.ezee_room_type_code === selectedValue);
    if (existsInCategories) {
      window.App.toastShow('warn', t('warning'), t('ezee_room_type_exists'));
      setLoading(false)
    } else {
      apiCall('PATCH', 'ezee/residential-category/' + target.id, {
        ezee_room_type_id: droppedItem.id,
        ezee_room_type_code: droppedItem.id,
        ezee_channel_sellable_units: null,
        ezee_sync_enabled: true
      })
        .then(response => {
          apiCall('GET', 'ezee/residential-category?search[accommodation]=' + props.accommodationId)
            .then(response => {
              setCategories(response.data.data.items);
              setLoading(false)
              document.querySelectorAll('.dropzone').forEach((div) => {
                div.classList.remove('active');
              });
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              setLoading(false)
              document.querySelectorAll('.dropzone').forEach((div) => {
                div.classList.remove('active');
              });
            })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    //console.log(handleDragOver)
  };

  useEffect(() => {
    setLoading(true)
    apiCall('GET', 'accommodation')
      .then(response => {
        setAccommodations(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (props.accommodationId) {
      apiCall('GET', 'ezee/residential-category?search[accommodation]=' + props.accommodationId)
        .then(response => {
          setCategories(response.data.data.items);
          apiCall('GET', 'accommodation/' + props.accommodationId + '/ezee/room-types')
            .then(response => {
              setRoomTypes(response.data.items);
              setLoading(false)
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              setLoading(false)
            })
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })

    }
  }, [props.accommodationId, window.App.state.rerenderEzeeroomtypesDnd])

  return (
    <>
      {loading &&
        <ProgressBar mode="indeterminate" style={{height: '5px'}}></ProgressBar>
      }
      <Panel>
        <div className={"p-grid p-mb-1"}>
          <div className={"p-col-12 p-lg-6 p-col-align-center"}>
            <h2 className={"p-m-0"}>{t('ezee_category_pairing')}</h2>
          </div>
          <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
            <Dropdown  options={accommodations}
                      className={"p-ml-2"}
                      optionLabel="name"
                      optionValue="id"
                      disabled={loading}
                      id={"accommodation"}
                      emptyMessage={t('empty_message')}
                      onChange={(e) => {
                        props.onAccommodationChange(e.value)
                        apiCall('GET', 'ezee/residential-category?search[accommodation]=' + e.value)
                          .then(response => {
                            setCategories(response.data.data.items);
                            apiCall('GET', 'accommodation/' + e.value + '/ezee/room-types')
                              .then(response => {
                                setRoomTypes(response.data.items);
                              })
                              .catch(error => {
                                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                              })
                          })
                          .catch(error => {
                            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                          })
                      }}
                      value={Number(props.accommodationId)}
            />
          </div>
        </div>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"tab"} tabNumber={2}/>
        {categories && roomTypes[0] ? (
          <>
            {categories.map((category, index) => {
              return (
                <>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                      <div className={"p-grid"}>
                        <div className={"p-col"}>
                          <label htmlFor="name">{t('category')} {t('name').toLowerCase()}</label>
                          <span className="p-d-block p-text-bold">
                          {category.name}
                        </span>
                        </div>
                        <div className={"p-col p-col-align-center"}>
                          <label htmlFor="accommodation">{t('accommodation')}</label>
                          <span className="p-d-block p-text-bold">
                        {category?.accommodation?.name}
                      </span>
                        </div>
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center"}
                         onDragOver={handleDragOver}
                         onDrop={(e) => handleDrop(e, category)}>
                      <div className={"dropzone"} style={{height: '68px', borderRadius: '4px'}}>
                        {(() => {
                          if (roomTypes && roomTypes[0] && categories && categories[0]) {
                            let _roomType = roomTypes.find(item => item.id === category.ezee_room_type_id)
                            // console.log(_roomType)
                            if (_roomType) {
                              return (
                                <Card className={"p-px-3"}>
                                  <div className={"p-grid"}>
                                    <div className={"p-col-10 p-p-0 p-m-0 p-col-align-center"}>
                                      <span className="p-d-block p-text-bold p-mt-2">
                                        {_roomType.name}
                                      </span>
                                      <span className="p-d-block p-text-nowrap">
                                        # {_roomType.id}
                                      </span>
                                    </div>
                                    <div className={"p-col-2 p-p-0 p-m-0 p-col-align-center p-text-right"}>
                                      <Button type="button" className={"p-button-danger p-button-sm p-mt-1"}
                                              onClick={() => {
                                                setLoading(true)
                                                apiCall('PATCH', 'ezee/residential-category/' + category.id, {
                                                  ezee_room_type_id: null,
                                                  ezee_room_type_code: null,
                                                  ezee_channel_sellable_units: null,
                                                  ezee_sync_enabled: null
                                                })
                                                  .then(response => {
                                                    apiCall('GET', 'ezee/residential-category?search[accommodation]=' + props.accommodationId)
                                                      .then(response => {
                                                        setCategories(response.data.data.items);
                                                        setLoading(false)
                                                      })
                                                      .catch(error => {
                                                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                        setLoading(false)
                                                      })
                                                  })
                                                  .catch(error => {
                                                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                    setLoading(false)
                                                  })
                                              }}>
                                        <i className={"pi pi-trash"}></i>
                                      </Button>
                                    </div>
                                  </div>
                                </Card>
                              )
                            } else {
                              return (
                                <div style={{border: '2px dashed #e6e9ec', height: '68px', borderRadius: '4px'}}>

                                </div>
                              )
                            }
                          }
                        })()}
                      </div>
                    </div>
                  </div>
                  <hr className={"p-mb-3"}/>
                </>
              )
            })}
          </>
        ) : (
          <p>
            {t('no_categories_found')}
          </p>
        )}
      </Panel>
      <Panel className={"p-mt-3"}>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6 p-col-align-center"}>
            <h2 className={"p-m-0"}>{t('ezee_room_types')}</h2>
          </div>
          <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>

          </div>
        </div>
        {roomTypes && roomTypes[0] ? (
          <div className={"p-grid"}>
            {roomTypes.map((roomType, index) => {
              if (!categories.some(target => target.ezee_room_type_code === roomType.id)) {
                return (
                  <>
                    <div className={"p-col-12 p-lg-4"}>
                      <Card
                        draggable
                        style={{cursor: 'move', position: 'relative'}}
                        onDragStart={(e) => handleDragStart(e, roomType)}
                        onDragEnd={(e) => handleDragEnd(e, roomType)}
                        className={"p-p-0"}>
                      <span style={{
                        position: 'absolute',
                        right: '0',
                        bottom: '0',
                        backgroundColor: '#ebedf2',
                        borderBottomRightRadius: '3px',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        lineHeight: 1
                      }}>
                        <i className={"pi pi-th-large"} style={{color: '#495057'}}></i>
                      </span>
                      <span className="p-d-block p-text-bold" style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%'
                      }}>
                        {roomType.name}
                      </span>
                        <span className="p-d-block p-text-nowrap">
                        # {roomType.id}
                      </span>
                      </Card>
                    </div>
                  </>
                )
              }
            })}
          </div>
        ) : (
          <p>
            {t('no_roomtypes_found')}
          </p>
        )}
      </Panel>
    </>
  )
}
export default withTranslation('common')(_FM_EzeeroomtypesDndComponent);
